import { z } from 'zod';
import { apiEnvelope, numericString, optionalText } from './backend.schema';

/** Número en cero (`"0.000000"`) como `null`: el backend lo usa para "sin dato". */
const optionalNumber = numericString.transform((value) => (value === 0 ? null : value));

/**
 * Fila de `GET /seed-backoffice/flete` (`ws_SemTabFlete`); números como string.
 * El backend todavía no informa transportista, chofer, chasis, acoplado ni factura: quedan `null`.
 */
export const FleteApiSchema = z
  .object({
    Nro_Turno: numericString,
    PLote_Codigo: optionalText,
    Kilos: numericString,
    Contrato_Numero: optionalNumber,
    Monto: optionalNumber,
    Bolsones_Esperados: numericString,
  })
  .transform((f) => ({
    turno: String(f.Nro_Turno),
    lote: f.PLote_Codigo,
    transportista: null as string | null,
    chofer: null as string | null,
    chasis: null as string | null,
    acoplado: null as string | null,
    kilos: f.Kilos,
    contrato: f.Contrato_Numero == null ? null : String(f.Contrato_Numero),
    esperados: f.Bolsones_Esperados,
    fc: null as string | null,
    monto: f.Monto,
  }));

/** `{ data: { items, Message } }`, o `{ data: { Message } }` sin filas. */
export const FletesRespSchema = apiEnvelope(z.object({ items: z.array(FleteApiSchema).optional() })).transform(
  (r) => r.data.items ?? [],
);

export type Flete = z.output<typeof FleteApiSchema>;
